<template>
    <a-spin tip="Carregando..." :spinning="spinning">
        <div class="container">
            <a-card>
                <template #title>
                    <a-breadcrumb separator=">">
                        <a-breadcrumb-item>
                            <FileOutlined />
                            <a href="/maps/thematic-layers"><span>Camadas Temáticas</span></a>
                        </a-breadcrumb-item>
                        <a-breadcrumb-item>
                            {{ isEdit ? 'Editar Camada Temática' : 'Cadastrar Camada Temática' }}
                        </a-breadcrumb-item>
                    </a-breadcrumb>
                </template>

                <a-form
                    ref="formRef"
                    layout="vertical"
                    :model="form"
                    :rules="rules"
                    validate-on-rule-change
                    @submit.prevent
                >
                    <a-tabs v-model:activeKey="mainTab" :destroyInactiveTabPane="false">
                        <a-tab-pane key="general" tab="Geral">
                            <a-divider orientation="left">Identificação</a-divider>
                            <a-row :gutter="[16, 8]">
                                <a-col :xs="24" :lg="12">
                                    <a-form-item name="name" label="Nome">
                                        <a-input v-model:value="form.name" allowClear />
                                    </a-form-item>
                                </a-col>
                                <a-col :xs="24" :lg="12">
                                    <a-form-item name="description" label="Descrição">
                                        <a-input v-model:value="form.description" allowClear />
                                    </a-form-item>
                                </a-col>
                                <a-col :xs="24" :md="8">
                                    <a-form-item name="geometry_type" label="Tipo de Geometria">
                                        <a-select
                                            v-model:value="form.geometry_type"
                                            :options="geometryTypeOptions"
                                            placeholder="Selecione"
                                            allowClear
                                            @change="onGeometryChange"
                                        />
                                    </a-form-item>
                                </a-col>
                                <a-col :xs="24" :md="16">
                                    <a-form-item label="Tutorial">
                                        <a-select
                                            v-model:value="form.faq_id"
                                            :options="faqsOptions"
                                            allow-clear
                                            placeholder="Selecione (opcional)"
                                        />
                                    </a-form-item>
                                </a-col>
                            </a-row>

                            <a-divider orientation="left">Exibição</a-divider>
                            <a-row :gutter="[16, 8]">
                                <a-col :xs="24" :sm="8">
                                    <a-form-item label="Visível no LayerSwitcher" class="switch-item">
                                        <a-switch v-model:checked="form.display_in_layer_switcher" />
                                    </a-form-item>
                                </a-col>
                                <a-col :xs="24" :sm="8">
                                    <a-form-item label="Ativo" class="switch-item">
                                        <a-switch v-model:checked="form.active" />
                                    </a-form-item>
                                </a-col>
                                <a-col :xs="24" :sm="8">
                                    <a-form-item label="Público" class="switch-item">
                                        <a-switch v-model:checked="form.is_public" />
                                    </a-form-item>
                                </a-col>
                            </a-row>

                            <a-divider orientation="left">Aparência</a-divider>
                            <a-row :gutter="[16, 8]">
                                <template v-if="isMultiPolygon">
                                    <a-col :xs="24" :sm="8" :md="6">
                                        <a-form-item name="border_color" label="Cor da Borda">
                                            <input type="color" v-model="form.border_color" class="ant-input color-input" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :xs="24" :sm="8" :md="6">
                                        <a-form-item name="border_size" label="Espessura da Borda">
                                            <a-input-number
                                                v-model:value="form.border_size"
                                                :min="0"
                                                :max="20"
                                                style="width: 100%"
                                            />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :xs="24" :sm="8" :md="6">
                                        <a-form-item name="fill_color" label="Cor de Preenchimento">
                                            <input type="color" v-model="form.fill_color" class="ant-input color-input" />
                                        </a-form-item>
                                    </a-col>
                                </template>

                                <a-col :xs="24" :md="isMultiPolygon ? 6 : 12">
                                    <a-form-item
                                        name="icon_path"
                                        :label="`Ícone${isPoint ? ' (obrigatório)' : ''}`"
                                    >
                                        <div class="thumb-line">
                                            <div v-if="form.icon_path" class="thumb-wrapper">
                                                <img class="thumb-img" :src="form.icon_path" alt="Ícone selecionado" />
                                            </div>
                                            <a-button @click="showImagePicker = true">Selecionar</a-button>
                                        </div>
                                        <small v-if="form.icon_path" class="text-muted">{{ form.icon_path }}</small>
                                    </a-form-item>
                                </a-col>
                            </a-row>
                        </a-tab-pane>

                        <a-tab-pane key="content" tab="Conteúdo">
                            <a-row :gutter="[16, 16]">
                                <a-col :xs="24" :xl="12">
                                    <a-card size="small" title="SQL e-cidade" class="content-card">
                                        <a-alert
                                            message="Opcional. Campos retornados podem ser usados no SQL do Geo com @nome_do_campo."
                                            type="info"
                                            show-icon
                                            class="mb-2"
                                        />
                                        <a-form-item name="sql" label="Consulta">
                                            <Codemirror
                                                v-model:value="form.sql"
                                                :options="cmOptions"
                                                border
                                                KeepCursorInEnd
                                                height="260"
                                                @change="() => clearValidate(['sql'])"
                                            />
                                        </a-form-item>
                                        <div class="sql-actions">
                                            <a-button type="primary" @click="testSql('ecidade')">Testar SQL</a-button>
                                            <a-typography-text type="danger" v-if="sqlErrorEcidade">
                                                {{ sqlErrorEcidade }}
                                            </a-typography-text>
                                        </div>
                                        <a-typography-text
                                            v-if="ecidadeVariables.length"
                                            type="secondary"
                                            class="variables-hint"
                                        >
                                            Variáveis: {{ ecidadeVariables.map(v => `@${v}`).join(', ') }}
                                        </a-typography-text>
                                    </a-card>
                                </a-col>

                                <a-col :xs="24" :xl="12">
                                    <a-card size="small" title="SQL Geo" class="content-card">
                                        <a-alert
                                            message="Obrigatório. Use @campo quando houver SQL e-cidade; caso contrário, consulta independente com geometria (geom/geometry)."
                                            type="info"
                                            show-icon
                                            class="mb-2"
                                        />
                                        <a-form-item name="sql_geo" label="Consulta">
                                            <Codemirror
                                                v-model:value="form.sql_geo"
                                                :options="cmOptions"
                                                border
                                                KeepCursorInEnd
                                                height="260"
                                                @change="() => clearValidate(['sql_geo'])"
                                            />
                                        </a-form-item>
                                        <div class="sql-actions">
                                            <a-button type="primary" @click="testSql('geo')">Testar SQL</a-button>
                                            <a-typography-text type="danger" v-if="sqlErrorGeo">
                                                {{ sqlErrorGeo }}
                                            </a-typography-text>
                                        </div>
                                    </a-card>
                                </a-col>

                                <a-col :span="24">
                                    <a-card size="small" title="Referência" class="content-card">
                                        <p class="vars-intro">
                                            Use os nomes dos campos como variáveis no HTML no formato
                                            <code>$nome_do_campo</code>.
                                            <span v-if="referenceVariables.length"> Campos disponíveis:</span>
                                        </p>
                                        <ul v-if="referenceVariables.length" class="column-var-list">
                                            <li v-for="col in referenceVariables" :key="col">
                                                <code>{{ '$' + col }}</code>
                                            </li>
                                        </ul>
                                        <p v-else class="muted">
                                            Teste um dos SQLs acima para listar os campos disponíveis.
                                        </p>
                                        <a-form-item name="reference" label="HTML exibido no mapa">
                                            <div class="reference-editor">
                                                <Codemirror
                                                    v-model:value="form.reference"
                                                    :options="cmHtmlOptions"
                                                    height="260"
                                                    class="cm-component"
                                                    :border="true"
                                                    @change="() => clearValidate(['reference'])"
                                                />
                                            </div>
                                        </a-form-item>
                                    </a-card>
                                </a-col>
                            </a-row>
                        </a-tab-pane>
                    </a-tabs>

                    <a-divider class="form-footer-divider" />

                    <a-form-item class="actions">
                        <a-space>
                            <a-tooltip :title="isEdit ? 'Salvar alterações' : 'Salvar'">
                                <a-button size="large" type="primary" @click="save" class="center-flex">
                                    <template #icon><SaveOutlined style="font-size: 18px;" /></template>
                                </a-button>
                            </a-tooltip>
                            <a-tooltip title="Cancelar">
                                <a-button size="large" href="/maps/thematic-layers" class="center-flex">
                                    Cancelar
                                </a-button>
                            </a-tooltip>
                        </a-space>
                    </a-form-item>
                </a-form>
            </a-card>

            <a-modal
                v-model:open="showImagePicker"
                title="Imagens Gerais"
                :footer="null"
                @cancel="showImagePicker = false"
                destroyOnClose
            >
                <ClientImagesPicker
                    :selected-image-path="form.icon_path"
                    @save="handleImageSave"
                    @cancel="showImagePicker = false"
                />
            </a-modal>
        </div>
    </a-spin>
</template>

<script setup>
import { ref, reactive, computed, onMounted } from 'vue'
import { FileOutlined, SaveOutlined } from '@ant-design/icons-vue'
import { notification } from 'ant-design-vue'
import ClientImagesPicker from '../../Components/ClientImagesPicker.vue'
import Codemirror from 'codemirror-editor-vue3'
import 'codemirror/mode/sql/sql.js'
import 'codemirror/mode/htmlmixed/htmlmixed'
import 'codemirror/theme/neat.css'

const props = defineProps({ id: { type: [Number, String], default: null } })
const isEdit = computed(() => !!props.id)

const API_BASE = '/api/maps/thematic-layers'
const API_FAQS = '/api/configurations/faqs'
const API_TEST_SQL = '/maps/carga/sql'

const spinning = ref(false)
const formRef = ref(null)
const mainTab = ref('general')
const showImagePicker = ref(false)

const form = reactive({
    id: null,
    display_in_layer_switcher: true,
    active: true,
    is_public: false,
    description: '',
    name: '',
    geometry_type: 'MultiPolygon',
    query_layer: null,
    sql: '',
    reference: '',
    sql_geo: '',
    faq_id: null,
    permission_id: null,
    border_color: '#000000',
    border_size: 1,
    fill_color: '#FFFFFF',
    icon_path: null
})

const geometryTypeOptions = [
    { label: 'Point', value: 'Point' },
    { label: 'MultiPolygon', value: 'MultiPolygon' }
]

const isPoint = computed(() => form.geometry_type === 'Point')
const isMultiPolygon = computed(() => form.geometry_type === 'MultiPolygon')

const faqsOptions = ref([])
const ecidadeVariables = ref([])
const geoVariables = ref([])
const ecidadeSampleRow = ref(null)
const sqlErrorEcidade = ref('')
const sqlErrorGeo = ref('')

const cmOptions = {
    mode: 'text/x-plsql',
    lineNumbers: true,
    theme: 'neat',
}

const cmHtmlOptions = {
    mode: 'text/html',
    theme: 'default',
    readOnly: false,
    lineNumbers: true,
    lineWiseCopyCut: true,
    gutters: ['CodeMirror-lint-markers'],
    lint: true,
}

const geometryFields = ['geom', 'geometry', 'centroid']

const referenceVariables = computed(() => {
    const source = ecidadeVariables.value.length ? ecidadeVariables.value : geoVariables.value
    return source.filter(col => !geometryFields.includes(col))
})

onMounted(async () => {
    await loadFaqs()
    if (isEdit.value) await loadItem(props.id)
})

const loadFaqs = async () => {
    try {
        const { data } = await window.axios.get(API_FAQS)
        faqsOptions.value = (data?.data || []).map(f => ({ label: f.name, value: f.id }))
    } catch {}
}

const loadItem = async (id) => {
    try {
        spinning.value = true
        const { data } = await window.axios.get(`${API_BASE}/${id}`)
        const r = data?.data || {}
        Object.assign(form, r)
        form.sql = form.sql ?? ''
        form.sql_geo = form.sql_geo ?? ''
        form.reference = form.reference || r.reference_geo || ''
    } finally {
        spinning.value = false
    }
}

const handleImageSave = (payload) => {
    const path = typeof payload === 'object' && payload?.path != null ? payload.path : payload
    form.icon_path = path
    showImagePicker.value = false
}

const onGeometryChange = () => {
    if (isPoint.value) {
        form.border_color = '#000000'
        form.border_size = 1
        form.fill_color = '#FFFFFF'
    } else if (isMultiPolygon.value) {
        form.border_color ||= '#000000'
        form.border_size = Number.isFinite(form.border_size) ? form.border_size : 1
        form.fill_color ||= '#FFFFFF'
    }
    clearValidate(['icon_path', 'border_color', 'border_size', 'fill_color'])
}

const applySqlVariables = (sql, row = {}) => {
    let resolved = sql
    Object.entries(row).forEach(([column, value]) => {
        const token = `@${column}`
        const replacement = value == null ? 'NULL' : String(value)
        resolved = resolved.split(token).join(replacement)
    })
    return resolved
}

const testSql = async (source = 'ecidade') => {
    const isGeo = source === 'geo'
    const setError = (msg) => {
        if (isGeo) sqlErrorGeo.value = msg
        else sqlErrorEcidade.value = msg
    }

    setError('')

    if (isGeo) {
        if (!String(form.sql_geo || '').trim()) {
            setError('Preencha o SQL.')
            return
        }
    } else if (!String(form.sql || '').trim()) {
        setError('Preencha o SQL.')
        return
    }

    try {
        spinning.value = true

        let sqlToTest = form.sql
        let sourceToTest = 'ecidade'

        if (isGeo) {
            const hasEcidadeSql = String(form.sql || '').trim().length > 0
            if (hasEcidadeSql) {
                let sampleRow = ecidadeSampleRow.value
                if (!sampleRow) {
                    const ecidadeResponse = await window.axios.post(API_TEST_SQL, {
                        sql: form.sql,
                        source: 'ecidade',
                    })
                    if (ecidadeResponse.data?.error || !ecidadeResponse.data?.data?.valido) {
                        setError(ecidadeResponse.data?.message || 'SQL do e-cidade inválido.')
                        return
                    }
                    const rows = ecidadeResponse.data?.data?.dados || []
                    if (!rows.length) {
                        setError('SQL do e-cidade não retornou registros para montar as variáveis.')
                        return
                    }
                    sampleRow = rows[0]
                    ecidadeSampleRow.value = sampleRow
                    ecidadeVariables.value = Object.keys(sampleRow)
                }
                sqlToTest = applySqlVariables(form.sql_geo, sampleRow)
            } else {
                sqlToTest = form.sql_geo
                ecidadeSampleRow.value = null
                ecidadeVariables.value = []
                geoVariables.value = []
            }
            sourceToTest = 'geo'
        }

        const { data } = await window.axios.post(API_TEST_SQL, {
            sql: sqlToTest,
            source: sourceToTest,
        })

        if (data?.error || !data?.data?.valido) {
            setError(data?.message || 'SQL inválido.')
            return
        }

        if (!isGeo) {
            const rows = data?.data?.dados || []
            ecidadeSampleRow.value = rows[0] || null
            ecidadeVariables.value = rows[0] ? Object.keys(rows[0]) : []
            geoVariables.value = []
        } else {
            const rows = data?.data?.dados || []
            geoVariables.value = rows[0] ? Object.keys(rows[0]) : []
        }

        notify('success', 'SQL válido!')
    } catch {
        setError('Falha ao testar SQL.')
    } finally {
        spinning.value = false
    }
}

const rules = reactive({
    name: [
        {
            async validator () {
                if (!String(form.name || '').trim()) throw new Error('Informe o nome')
            },
            trigger: ['change', 'blur']
        }
    ],
    description: [
        {
            async validator () {
                if (!String(form.description || '').trim()) throw new Error('Informe a descrição')
            },
            trigger: ['change', 'blur']
        }
    ],
    geometry_type: [
        {
            async validator () {
                if (!form.geometry_type) throw new Error('Selecione o tipo de geometria')
            },
            trigger: ['change', 'blur']
        }
    ],
    sql_geo: [
        {
            async validator () {
                if (!String(form.sql_geo || '').trim()) throw new Error('Informe o SQL do Geo')
            },
            trigger: ['change', 'blur']
        }
    ],
    reference: [
        {
            async validator () {
                if (isReferenceEmpty(form.reference)) throw new Error('Informe a referência')
            },
            trigger: ['change', 'blur']
        }
    ],
    icon_path: [
        {
            async validator () {
                if (!isPoint.value) return
                if (!form.icon_path) throw new Error('Selecione um ícone (obrigatório para Point)')
            },
            trigger: ['change', 'blur']
        }
    ],
    border_color: [
        {
            async validator () {
                if (!isMultiPolygon.value) return
                if (!form.border_color) throw new Error('Informe a cor da borda')
            },
            trigger: ['change', 'blur']
        }
    ],
    border_size: [
        {
            async validator () {
                if (!isMultiPolygon.value) return
                const v = Number(form.border_size)
                if (!Number.isFinite(v) || v < 0) throw new Error('Informe a espessura da borda (número ≥ 0)')
            },
            trigger: ['change', 'blur']
        }
    ],
    fill_color: [
        {
            async validator () {
                if (!isMultiPolygon.value) return
                if (!form.fill_color) throw new Error('Informe a cor de preenchimento')
            },
            trigger: ['change', 'blur']
        }
    ]
})

const clearValidate = async (fields = []) => {
    try { await formRef.value?.clearValidate(fields) } catch {}
}

const isReferenceEmpty = (value) => {
    const raw = String(value || '').trim()
    if (!raw) return true
    const text = raw
        .replace(/<[^>]*>/g, ' ')
        .replace(/&nbsp;/gi, ' ')
        .replace(/\s+/g, ' ')
        .trim()
    return text === ''
}

const firstErrorTab = (errorFields = []) => {
    const names = errorFields.map(item => item.name?.[0] || item.name).filter(Boolean)
    if (names.some(name => ['sql', 'sql_geo', 'reference'].includes(name))) return 'content'
    return 'general'
}

const save = async () => {
    try {
        await formRef.value?.validate()

        spinning.value = true
        let resp

        if (isEdit.value) {
            resp = await window.axios.put(`${API_BASE}/${form.id}`, form)
            notify('success', resp?.data?.message || 'Camada temática atualizada!')
        } else {
            resp = await window.axios.post(API_BASE, form)
            notify('success', resp?.data?.message || 'Camada temática criada!')
        }

        window.location.href = `/maps/thematic-layers`
    } catch (e) {
        if (e?.errorFields) {
            mainTab.value = firstErrorTab(e.errorFields)
            notify('warning', e.errorFields[0]?.errors?.[0] || 'Preencha os campos obrigatórios.')
            return
        }

        const res = e?.response?.data
        const status = e?.response?.status

        if (status === 422 && res?.errors) {
            const errorNames = Object.keys(res.errors)
            if (errorNames.some(name => ['sql', 'sql_geo', 'reference'].includes(name))) {
                mainTab.value = 'content'
            }
            const firstError = Object.values(res.errors).flat()[0]
            notify('warning', firstError || res.message || 'Erro de validação.')
            return
        }

        if (res?.message) {
            notify('error', res.message)
        } else {
            notify('error', 'Falha ao salvar.')
        }
    } finally {
        spinning.value = false
    }
}

const notify = (type, description) =>
    notification[type]?.({ message: 'Notificação', description })
</script>

<style scoped>
.container { width: 100%; }

.center-flex {
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.mb-2 { margin-bottom: 8px; }

.text-muted { color: #8c8c8c; }

.switch-item :deep(.ant-form-item-control-input) {
    min-height: 32px;
}

.content-card {
    height: 100%;
}

.content-card :deep(.ant-card-body) {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.sql-actions {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px;
    margin-top: 4px;
}

.variables-hint {
    display: block;
    margin-top: 4px;
    font-size: 12px;
}

.color-input {
    width: 100%;
    height: 32px;
    padding: 2px 4px;
}

.form-footer-divider {
    margin: 8px 0 16px;
}

.actions {
    margin-bottom: 0;
}

.thumb-line {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
}

.thumb-wrapper {
    width: 120px;
    height: 90px;
    border: 1px solid #f0f0f0;
    border-radius: 6px;
    overflow: hidden;
    background: #fafafa;
    display: flex;
    align-items: center;
    justify-content: center;
}

.thumb-img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    display: block;
}

.cm-component {
    font-family: monospace;
}

.reference-editor {
    margin-top: 4px;
}

.vars-intro {
    margin: 0 0 8px;
}

.column-var-list {
    margin: 0 0 12px 1.2em;
    padding: 0;
}

.muted {
    color: #888;
    margin-bottom: 12px;
}
</style>
